module.exports = __webpack_public_path__ + "static/images/rocket.c2ff2ff9c50238f090ce4abf2e451314.svg";